export default __webpack_public_path__ + "static/media/large-yoga.135ced08.svg";